import { mapMutations, mapState, mapGetters } from "vuex";
import AppButtonRadioGroup from "@/components/AppButtonRadioGroup.vue";
import DashboardFilters from "@/components/DashboardFilters.vue";
import DashboardV2Mixin from "@/mixins/DashboardV2Mixin.vue";
import NavigationTabs from "@/components/NavigationTabs.vue";
import FlexColumn from "@/components/FlexColumn.vue";
import DateValue from "@/components/tableElements/DateValue.vue";
import PerformanceCards from "@/components/kpi-cards/dashboard_v2/PerformanceCards.vue";
import { EVENTS, APP_PERIOD_DROPDOWN_ELEMENTS } from "@/utils/constants";
import PerformancePeriodTable from "@/components/dashboard_v2/PerformancePeriodTable.vue";
import ListingPeriodTable from "@/components/dashboard_v2/ListingPeriodTable.vue";
import PerformanceProductTable from "@/components/dashboard_v2/PerformanceProductTable.vue";
import ProfitPeriodTable from "@/components/dashboard_v2/ProfitPeriodTable.vue";
import VendorPeriodTable from "@/components/dashboard_v2/VendorPeriodTable.vue";
import AppDropdown from "@/components/AppDropdown.vue";
import moment from "moment";
import ListingCards from "@/components/kpi-cards/dashboard_v2/ListingCards.vue";
import AdvertisingCards from "@/components/kpi-cards/dashboard_v2/AdvertisingCards.vue";
import AdvertisingPeriodTable from "@/components/dashboard_v2/AdvertisingPeriodTable.vue";
import { DATE_RANGES_FROM_SELECTOR, momentWeekType } from "@/utils/datepicker";
import LiteTableMixin from "@/mixins/LiteTableMixin.vue";
import CurrencyFilter from "@/components/new-filters/CurrencyFilter.vue";
import TabbedKpiCards from "@/components/kpi-cards/dashboard_v2/v2/TabbedKpiCards.vue";
import PeriodControllers from "@/components/PeriodControllers.vue";
import { FLOATING_COMPOUND_TABLE_STATES, FILTER_KEYS } from "../utils/constants";
import { FilterManager } from "@/store/filter";
export default {
  name: "DashboardV2Page",
  components: {
    AppButtonRadioGroup,
    DashboardFilters,
    NavigationTabs,
    FlexColumn,
    DateValue,
    PerformanceCards,
    ListingCards,
    AdvertisingCards,
    PerformancePeriodTable,
    ListingPeriodTable,
    PerformanceProductTable,
    AdvertisingPeriodTable,
    ProfitPeriodTable,
    VendorPeriodTable,
    AppDropdown,
    CurrencyFilter,
    TabbedKpiCards,
    PeriodControllers
  },
  mixins: [DashboardV2Mixin, LiteTableMixin],
  beforeUnmount() {
    window.$bus.off(EVENTS.REFRESH_DASHBOARD_V2, () => this.refreshAllKpis());
  },
  async mounted() {
    this.datePickerCommitterFunction = this.dashboardV2SetProductTablePeriod;
    this.$store.dispatch("dashboardV2SetDefaultCurrency");
    window.$bus.on(EVENTS.REFRESH_DASHBOARD_V2, () => this.refreshAllKpis());
    await this.initializeSellersFilter(this.dashboardSellersFilterSet);
    await this.initializeMarketplacesFilter(this.dashboardMarketplacesFilterSet, true);
    this.marketplaces_filter._key = "sales_channel";
    const filterManager = new FilterManager({
      sellersFilter: this.sellers_filter,
      marketplacesFilter: this.marketplaces_filter,
      rootPath: "dashboard/v2"
    });
    const secondaryFilters = {
      [FILTER_KEYS.PRODUCTS]: {
        storeFilter: this.products_filter,
        initializer: this.initializeProductsFilters
      },
      [FILTER_KEYS.SEGMENTS]: {
        storeFilter: this.segments_filter,
        initializer: this.initializeSegmentsFilter
      },
      [FILTER_KEYS.BRANDS]: {
        storeFilter: this.brands_filter,
        initializer: this.initializeBrandsFilter
      }
    };
    filterManager.registerAll(secondaryFilters);
    this.$store.dispatch('dashboardV2SetFilterManager', filterManager);
    await filterManager.refreshAll();
    this.$store.dispatch("dashboardV2SetProductTableGroupByElements");
    this.applyPeriodForDatePicker(this.periodGroupBy);
    this.refreshAllKpis();
    window.$bus.on(EVENTS.REFRESH_DASHBOARD_V2_SELLERS_SUB_FILTERS, async v => await this.refreshDashboardSellersSubFilters(v));
    window.$bus.on(EVENTS.REFRESH_DASHBOARD_V2_MARKETPLACES_SUB_FILTERS, async () => this.refreshDashboardMarketPlacesSubFilters());
    window.$bus.on(EVENTS.REFRESH_DASHBOARD_V2_PRODUCTS_SUB_FILTERS, async () => this.refreshDashboardProductsSubFilters());
  },
  data() {
    return {
      today: moment(),
      sellers: [],
      marketplaces: [],
      kpisLoading: true,
      periodTableLoading: true,
      productTableLoading: true,
      mediatorRefreshers: {
        KPIS: this.refreshKpis,
        PERIOD_TABLE: this.refreshPeriodTable,
        PRODUCT_TABLE: this.refreshProductTable
      },
      DATE_RANGES_FROM_SELECTOR,
      FLOATING_COMPOUND_TABLE_STATES
    };
  },
  computed: {
    ...mapState({
      isOmnyAdmin: state => state.auth.isOmnyAdmin,
      isOmnyUser: state => state.auth.isOmnyUser,
      kpis: state => state.dashboard_v2.kpis.data,
      currentPeriod: state => state.dashboard_v2.currentPeriod,
      periodSelectorOptions: state => state.dashboard_v2.periodSelectorOptions,
      tabs: state => state.dashboard_v2.tabs,
      productTable: state => state.dashboard_v2.product_table,
      productTableGroupBy: state => state.dashboard_v2.product_table.group_by_text,
      currentTabValue: state => state.dashboard_v2.currentTabValue,
      floatingTableState: state => state.dashboard_v2.product_table.state,
      currencies: state => state.dashboard_v2.currencies,
      sellers_filter: state => state.dashboard_v2.sellers_filter,
      marketplaces_filter: state => state.dashboard_v2.marketplaces_filter,
      segments_filter: state => state.dashboard_v2.segments,
      products_filter: state => state.dashboard_v2.products,
      brands_filter: state => state.dashboard_v2.brands,
      kpis_v2: state => state.dashboard_v2.kpis_v2.considered_kpis,
      periodSetting: state => state.dashboard_v2.period,
      filterManager: state => state.dashboard_v2.filterManager
    }),
    ...mapGetters(["dashboardV2GetPeriod", "dashboardV2GetPeriodCategory", "dashboardV2GetTab", "getSystemWeekType", "isUserInBetaAccessGroup", "dashboardV2GetPeriodOptions", "isVendorTabEnabledGet", "dashboardV2GetFilters", "currencyConfigQueryGet", "dateConfigQueryGet"]),
    currentSellerIds() {
      return this.sellers_filter.filterValues;
    },
    currentMarketplaceIds() {
      return this.marketplaces_filter.filterValues;
    },
    computedTabs() {
      return this.isVendorTabEnabledGet() ? [...this.tabs, {
        separator: true
      }, {
        text: "Vendor",
        value: "vendor",
        activeBg: "var(--market-50)",
        activeColor: "var(--market-800)",
        feature: 'dashboardvendortabfeature',
        event: "dashboardVendorTabOpened"
      }] : this.tabs;
    },
    period: {
      set(value) {
        this.$store.dispatch("dashboardV2SetPeriod", value);
        this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
        this.refreshMediator(["PERIOD_TABLE", "PRODUCT_TABLE"]);
      },
      get() {
        return this.dashboardV2GetPeriod();
      }
    },
    periodCategory: {
      set(value) {
        this.applyPeriodCategoryForDatePicker(this.datePickerDate, value);
        this.$store.dispatch("dashboardV2SetPeriodCategory", value);
      },
      get() {
        return this.dashboardV2GetPeriodCategory();
      }
    },
    tab: {
      async set(value) {
        this.$store.dispatch("dashboardV2SetTab", {
          tabIndex: value,
          tabValue: this.computedTabs[value].value
        });
      },
      get() {
        return this.dashboardV2GetTab();
      }
    },
    periodGroupBy() {
      return this.getPeriodGroupFromCurrentPeriod(this.currentPeriod, this.period);
    },
    getCurrentPeriodDate() {
      if (this.period === APP_PERIOD_DROPDOWN_ELEMENTS.WEEKLY.value) {
        return momentWeekType[this.getSystemWeekType]();
      }
      return this.currentPeriod[this.period].date;
    },
    periodOptions() {
      return this.dashboardV2GetPeriodOptions;
    },
    datePickerDate() {
      return this.productTable[this.currentTabValue].period;
    }
  },
  methods: {
    ...mapMutations(["dashboardSellersFilterSet", "dashboardMarketplacesFilterSet", "dashboardV2SetProductTablePeriod"]),
    setAllLoading(value) {
      this.kpisLoading = value;
    },
    async refreshKpis() {
      this.kpisLoading = true;
      await this.$store.dispatch("dashboardV2FetchKpis");
      this.kpisLoading = false;
    },
    handleErrorOccured() {
      this.announceNoAccounts();
      this.periodTableLoading = false;
      this.productTableLoading = false;
      this.kpisLoading = false;
    },
    async refreshPeriodTable() {
      this.periodTableLoading = true;
      await this.$store.dispatch("dashboardV2FetchPeriodTableData");
      this.periodTableLoading = false;
    },
    async refreshMediator(refresheeList) {
      const perf = [];
      perf.push(performance.now());
      refresheeList.forEach(refreshee => {
        this.mediatorRefreshers[refreshee]();
      });
      perf.push(performance.now());
    },
    async refreshProductTable() {
      this.productTableLoading = true;
      let previousPeriodCategory = this.periodCategory;
      //this.periodCategory = "prev_period";
      const groupByFetch = this.productTable[this.currentTabValue].data[this.productTableGroupBy]?.fetch;
      if (groupByFetch) await this.$store.dispatch(groupByFetch);
      //this.periodCategory = previousPeriodCategory;
      this.productTableLoading = false;
    },
    async handleDateChange(date) {
      if (!date) {
        date = this.applyPeriodForDatePicker(this.periodGroupBy, this.periodCategory);
      }
      this.storeDatePickerDate(date);
      await this.refreshMediator(["PRODUCT_TABLE"]);
    },
    handleSetPeriodTable(date) {
      this.handleSetLiteTablePeriod(date, this.period, this.handleDateChange, this.datePickerCompareTitle(this.periodCategory));
    },
    // Clear any evolution row selection without refetching.
    restoreEvolutionTable() {
      this.$store.commit("dashboardV2DeselectPeriodTable");
    },
    handleProductTableSort({
      sort,
      direction
    }) {
      this.$store.dispatch("dashboardV2SetProductTableSort", {
        sort,
        direction
      });
      this.refreshMediator(["PRODUCT_TABLE"]);
    },
    refreshAllKpis() {
      this.refreshMediator(["KPIS", "PRODUCT_TABLE", "PERIOD_TABLE"]);
    },
    handleApplyForCurrencyChange() {
      if (this.currencies.isModified) {
        this.currencies.apply();
        this.$store.dispatch("currencyConfigSetCurrency", this.currencies.filterValues[0]);
        this.refreshAllKpis();
      }
    },
    async refreshDashboardSellersSubFilters(check_local_storage) {
      await this.initializeMarketplacesFilter(this.dashboardMarketplacesFilterSet, check_local_storage);
      this.marketplaces_filter._key = "sales_channel";
      await this.filterManager.refreshAll();
    },
    async refreshDashboardMarketPlacesSubFilters() {
      await this.filterManager.refreshSet([FILTER_KEYS.PRODUCTS]);
    },
    async refreshDashboardProductsSubFilters() {
      const segment_list = this.segments_filter.selected.map(({
        segment
      }) => segment).filter(Boolean);
      await this.filterManager.refreshSet([FILTER_KEYS.PRODUCTS], {
        segment_list
      });
    }
  }
};